<template>
  <div :class="{'b-bottom': !onlyShow}">
    <div class="columns">
      <div class="column is-6">
        <sc-field
          label="Ação"
          prop="first">
            <sc-select
              :disabled="onlyShow"
              expanded
              v-model="clonedActionForm.label"
              @input="changeInputAction(clonedActionForm.label)">
                <option
                  v-for="condition in srcConditionalAction"
                  :key="condition.id"
                  :value="condition.value">
                    {{ condition.text }}
                </option>
            </sc-select>  
        </sc-field>
      </div>
      <div class="column is-6">
        <sc-field
          class="flex_col"
          label="Valor"
          prop="second"
          v-if="currencyInput.indexOf(clonedActionForm.label) >= 0">
            <sc-decimal
              v-if="!onlyShow"
              prefix="R$"
              :value="actionForm.action_condition.value"
              @input="inputCurrencyInput"/>
            <input
              v-if="onlyShow"
              class="input"
              disabled
              type="text"
              :value="'R$' + clonedActionForm.action_condition.value">
        </sc-field>
        <sc-field
          class="flex_col"
          label="Valor"
          prop="second"
          v-if="numberInput.indexOf(clonedActionForm.label) >= 0">
            <sc-input
              :disabled="onlyShow"
              min="0"
              v-model="clonedActionForm.action_condition.value"
              type="number"/>
        </sc-field>
        <sc-field
          class="flex_col"
          label="Valor"
          prop="second"
          v-if="optionInput.indexOf(clonedActionForm.label) >= 0">
            <div class="columns flex_col">
              <div class="column is-12">
                <sc-select
                  :disabled="onlyShow"
                  expanded
                  @input="changeInputActionValue(clonedActionForm.action_condition.value)"
                  v-model="clonedActionForm.action_condition.value">
                    <option
                      v-for="(conditionalComplex, index) in srcFmtConditionalComplex"
                      v-if="srcOptionInput.indexOf(clonedActionForm.label) >= 0"
                      :key="index"
                      :value="conditionalComplex.value">
                        {{ conditionalComplex.text }}
                    </option>
                    <option
                      v-for="(conditionalComplex, index) in srcFmtConditionalSimple"
                      v-if="srcOptionInput.indexOf(clonedActionForm.label) < 0"
                      :key="index"
                      :value="conditionalComplex.value">
                        {{ conditionalComplex.text }}
                    </option>
                </sc-select>
              </div>
            </div>
        </sc-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <sc-field
          v-if="showDmSelect">
            <sc-quoting-dm-all
              :disabled="onlyShow"
              v-model="clonedActionForm.action_condition.param" />
        </sc-field>
        <sc-field
          v-if="showMethodTypesSelect">
            <sc-select
              :disabled="onlyShow"
              expanded
              v-model="clonedActionForm.action_condition.param">
                <option :value="null">Todos</option>
                <option
                  v-for="methodType in srcMethodTypes"
                  :key="methodType.id"
                  :value="methodType.type">
                    {{ methodType.text }}
                </option>
            </sc-select>
        </sc-field>
      </div>
      <div class="column is-6 buttons">
        <sc-field class="align-right">
          <sc-button
            @click="handleActionEvt()"
            :icon="btnIcon"
            :text="btnText"
            v-if="clonedActionForm.label !== 'CONSUME' || !onlyShow"
            theme="primary"
            type="button"/>
          <sc-button
            @click="removeAction()"
            icon="times"
            text="Remover Ação"
            theme="danger"
            type="button"
            v-if="onlyShow"/>
        </sc-field>
      </div>
    </div>
  </div>
</template>

<script>
  import { Lodash } from '@intelipost-js/secure-providers';
  import {
    ScButton,
    ScField,
    ScIcon,
    ScInput,
    ScSelect,
    ScDecimal,
  } from '@intelipost-js/secure-components';
  import ScQuotingDmAll from '../sc-quoting-dm-all/ScQuotingDmAll.vue';
  import EnumConditionalAction from '../../enum/EnumConditionalAction.js';
  import EnumConditionalComplex from '../../enum/EnumConditionalComplex.js';
  import EnumMethodTypes from '../../enum/EnumMethodTypes.js';

  export default {
    name: 'sc-quoting-return-tbl-form-action',
    props: {
      actionForm: {
        type: Object,
      },
      configIndex: {
        type: Number,
        required: true,
      },
      onlyShow: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        clonedActionForm: {
          label: '',
          action_condition: {
            param: null,
            value: null,
          },
        },
        showCurrency: true,
        currencyInput: [
          'FIX_PRICE',
          'CHANGE_PRICE',
        ],
        numberInput: [
          'CHANGE_DAYS',
          'FIX_DAYS',
        ],
        optionInput: [
          'COPY_DAYS',
          'COPY_PRICE',
          'EXCLUDE_ME',
        ],
        srcOptionInput: [
          'COPY_DAYS',
          'COPY_PRICE',
        ],
        srcCopyActions: [
          'COPY_DAYS',
          'COPY_PRICE',
        ],
      };
    },
    watch: {
      actionForm(newValue) {
        this.clonedActionForm = Lodash.cloneDeep(newValue);
      },
    },
    computed: {
      srcConditionalAction() {
        return EnumConditionalAction;
      },
      srcFmtConditionalComplex() {
        return EnumConditionalComplex.filter(conditionalComplex => ['BEST', 'WORST', 'ALL']
          .indexOf(conditionalComplex.value) < 0,
        );
      },
      srcFmtConditionalSimple() {
        return EnumConditionalComplex.filter(conditionalComplex => ['BEST', 'WORST', 'ALL']
          .indexOf(conditionalComplex.value) >= 0,
        );
      },
      srcMethodTypes() {
        return EnumMethodTypes;
      },
      showDmSelect() {
        if (this.clonedActionForm.label !== 'CONSUME') {
          return this.clonedActionForm.action_condition.value === 'DM' &&
            this.srcCopyActions.indexOf(this.clonedActionForm.label) >= 0;
        }
        return false;
      },
      showMethodTypesSelect() {
        if (this.clonedActionForm.label !== 'CONSUME') {
          return this.clonedActionForm.action_condition.value !== 'DM' &&
            this.srcCopyActions.indexOf(this.clonedActionForm.label) >= 0;
        }
        return false;
      },
      btnText() {
        return this.onlyShow ? 'Editar Ação' : 'Salvar Ação';
      },
      btnIcon() {
        return this.onlyShow ? 'pen' : 'plus';
      },
    },
    methods: {
      addAction() {
        this.$emit('getactionevt', {
          action: this.clonedActionForm,
          configIndex: this.configIndex,
          evt: 'add',
        });
      },
      editAction() {
        this.$emit('getactionevt', {
          action: this.clonedActionForm,
          configIndex: this.configIndex,
          evt: 'edit',
        });
      },
      changeInputAction(action) {
        if (this.currencyInput.indexOf(action) >= 0 || this.numberInput.indexOf(action) >= 0) {
          this.clonedActionForm.action_condition.param = null;
          this.clonedActionForm.action_condition.value = 0;
        }

        if (action === 'COPY_DAYS' || action === 'COPY_PRICE') {
          this.clonedActionForm.action_condition.param = null;
          this.clonedActionForm.action_condition.value = 'CHEAPEST';
        }

        if (action === 'CONSUME') {
          this.clonedActionForm.action_condition.param = null;
          this.clonedActionForm.action_condition.value = null;
        }
      },
      changeInputActionValue(value) {
        this.clonedActionForm.action_condition.param = null;
        if (value === 'DM') {
          this.clonedActionForm.action_condition.param = 1;
        }
      },
      inputCurrencyInput(value) {
        this.clonedActionForm.action_condition.value = value;
      },
      handleActionEvt() {
        if (this.onlyShow) {
          this.editAction();
        } else {
          this.addAction();
        }
      },
      removeAction() {
        this.$emit('getactionevt', {
          action: this.clonedActionForm,
          configIndex: this.configIndex,
          evt: 'delete',
        });
      },
    },
    mounted() {
      this.clonedActionForm = Lodash.cloneDeep(this.actionForm);
    },
    components: {
      ScButton,
      ScField,
      ScIcon,
      ScInput,
      ScSelect,
      ScDecimal,
      ScQuotingDmAll,
    },
  };
</script>

<style lang="scss" scoped>
  .align-right {
    display: flex;
    justify-content: flex-end;
  }

  .b-bottom {
    border-bottom: 2px solid #002716;
    padding-bottom: .6rem;
  }

  .flex_col {
    flex-direction: column;
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-tbl/ScQuotingReturnTblFormAction.vue?08f65642